import _ from 'lodash';

import { consumerDispensaries } from 'shared/graphql/dispensary/queries';
import { hasNonCashPaymentOptions } from 'shared/helpers/dispensaries';

export default async function onCheckoutMount({ UI, Cart, User, apolloClient, showErnie, CheckoutCtx }) {
  const { isVariant } = CheckoutCtx;
  const { embeddedCName, currentAddress } = UI;
  const { order } = Cart;

  if (User.loggedIn) {
    // if user is logged in with token that has been invalidated, log them out
    const isValidUser = await User.checkValidUser();

    if (!isValidUser) {
      User.logout(null);
    }
  }

  if (!order.dispensary) {
    showErnie('Please add items to your cart before visiting checkout.', 'danger');
    if (isVariant('default') || !embeddedCName) {
      UI.showHome(true);
    } else {
      UI.showMenu(embeddedCName, true);
    }
    return;
  }

  if (!hasNonCashPaymentOptions(order.dispensary)) {
    Cart.setPaymentMethod('cash');
  }

  // set order customer type
  Cart.order.isGuestOrder = !User.exists;

  const results = await Promise.all([
    apolloClient
      .query({
        query: consumerDispensaries,
        variables: {
          dispensaryFilter: {
            cNameOrID: order.dispensary.id,
            destinationTaxState: currentAddress?.state,
            destinationTaxZipcode: currentAddress?.zipcode,
            nearLat: currentAddress?.lat,
            nearLng: currentAddress?.lng,
          },
        },
      })
      .catch((err) => console.error(err)),
  ]);

  const consumerDispensary = _.get(results[0], 'data.filteredDispensaries[0]', {});

  if (!_.isEmpty(consumerDispensary)) {
    _.set(Cart.order, 'dispensary', { ...consumerDispensary });
  }
}
